/**
 * Kod wygenerowany automatycznie przez automatyczne narz�dzie (problemy zg�asza� do Tomasza Grze�kiewicza)
 * nie zmieniaj tego pliku, wszystkie zmiany zostan� nadpisane automatycznie
 */
import {Api} from "../index";
import {ReactivityValidator} from "../../utils/ReactivityValidator"

export const RatingParameter = {

	delete (context, contestRatingParameterId, onSuccess, onError, options) {
		Api.delete(context,
			"/rating-parameter"
			+ "?contestRatingParameterId=" + contestRatingParameterId
			, null
			,(response) => {if ((typeof onSuccess) === 'function') { onSuccess(response); ReactivityValidator.validate(context);}}
			,onError
			,options);
	},

	getAllRatingParameters (context, contestId, onSuccess, onError, options) {
		Api.get(context,
			"/rating-parameter/all-rating-parameters"
			+ "?contestId=" + contestId
			,(response) => {if ((typeof onSuccess) === 'function') { onSuccess(response); ReactivityValidator.validate(context);}}
			,onError
			,options);
	},

	post (context, contestRatingParameterDTO, onSuccess, onError, options) {
		Api.post(context,
			"/rating-parameter"
			, contestRatingParameterDTO
			,(response) => {if ((typeof onSuccess) === 'function') { onSuccess(response); ReactivityValidator.validate(context);}}
			,onError
			,options);
	},

	put (context, contestRatingParameterDTO, onSuccess, onError, options) {
		Api.put(context,
			"/rating-parameter"
			, contestRatingParameterDTO
			,(response) => {if ((typeof onSuccess) === 'function') { onSuccess(response); ReactivityValidator.validate(context);}}
			,onError
			,options);
	},

};
